// extracted by mini-css-extract-plugin
export default {"controls":"CustomControls_controls__4Fova","submitButtons":"CustomControls_submitButtons__vkh+T"};